export default "__VITE_ASSET__ea9508cd__"